import React, { useState } from 'react';
import axios from 'axios';

const SearchSection = () => {

  const [inputSearchVal, setInputSearchVal] = useState('');
  const [inputLangVal, setInputLangVal] = useState('');
  const [inputDate, setInputDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [noSearchResults, setNoSearchResults] = useState(false);

  // useEffect(() => {
  //   setLoading(false);
  //   setNoSearchResults(false);
  // }, []);  

  function handleSearchChange(event) {
    setInputSearchVal(event.target.value);
  }

  function handleLanguageChange(event) {
    setInputLangVal(event.target.value);
  }

  function handleCategoryChange(category) {
    setInputDate(category);
  }

  function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
  }  

  function getUpdatedDate() {
    let today = new Date();
    if(inputDate == 'Last 7 Days') {
      today.setDate(today.getDate() - 7);
    }
    else if(inputDate == 'Last 14 Days') {
      today.setDate(today.getDate() - 14);
    }    
    else if(inputDate == 'Last 30 Days') {
      today.setDate(today.getDate() - 30);
    }    
    else if(inputDate == 'Last 60 Days') {
      today.setDate(today.getDate() - 60);
    }    
    else if(inputDate == 'Last 90 Days') {
      today.setDate(today.getDate() - 90);
    } 
    else if(inputDate == 'Last 180 Days') {
      today.setDate(today.getDate() - 180);
    } 
    else if(inputDate == 'Last 360 Days') {
      today.setDate(today.getDate() - 360);
    } 
    else {
      return '2000-01-01'
    }
    return formatDate(today)
  }

  function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    setNoSearchResults(false);

    let langVal = inputLangVal.toLowerCase();
    if(langVal == 'c#' || langVal == 'c #' || langVal == 'c sharp') {
      langVal = 'CSharp'
    }
    if(langVal == 'c++' || langVal == 'c ++' || langVal == 'c plus') {
      langVal = 'cpp'
    }

    let updatedDate = getUpdatedDate();
    return axios.get(`https://api.github.com/search/repositories?q=${inputSearchVal}+pushed:>${updatedDate}+language:${langVal}&sort=stars&order=desc&per_page=100`)
      .then(res => {
        const searchData = res.data;
        setSearchResults(searchData.items);
        if(searchResults.length == 0) {
          setNoSearchResults(true)
        } else {
          setNoSearchResults(false)
        }
        setLoading(false);
      })
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function resultMap() {
    if(loading) {
      return <div className="no-result">Loading...</div>
    }    
    if(searchResults.length == 0) {
      return <div className="no-result">No Results!</div>
    }
    return searchResults.map((result) => {
      let updated_at = new Date(Date.parse(result.updated_at)).toDateString();
      let starCount = numberWithCommas(result.stargazers_count);
      let repoDescription = result.description != undefined && result.description.length > 100 ? `${result.description.substring(0,100)}...` : result.description
      return (
        <div key={result.id} className="result-block">
          <div className="result-left">
            <div><a className="result-name" href={result.html_url} rel="noreferrer" target="_blank">{result.full_name}</a></div>
            <div className="result-description">{repoDescription}</div>
            <div className="result-date">{updated_at}</div>
          </div>
          <div className="result-right">
            <div className="star-block">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
              <div className="result-stars">{starCount}</div>
            </div>
            <div className="result-language"><label style={{ color: '#776f86' }}>language:</label> {result.language}</div>
          </div>
        </div>
      )
    })
  }

  return (
    <div className="search-main">
      <div className="search-header">
        <div className="search-bar">
          <input type="text" className="search-term" aria-label="search-term" placeholder="Search Repos" value={inputSearchVal} onChange={handleSearchChange} />
          <button type="submit" className="search-button" aria-label="search-button" onClick={(event) => handleSubmit(event)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          </button>
        </div>
        <div className="search-extra">
          <div className="search-extra-cols">
            <label>language</label>
            <input type="text" className="search-language" aria-label="search-language" placeholder="Language" value={inputLangVal} onChange={handleLanguageChange} />
          </div>
          <div className="search-extra-cols">
            <label>updated in</label>
            <select name="input-date" value={inputDate} aria-label="search-date" className="search-date" onChange={event => handleCategoryChange(event.target.value)}>
              <option id="0" >All Time</option>
              <option id="2" >Last 7 Days</option>
              <option id="3" >Last 14 Days</option>
              <option id="4" >Last 30 Days</option>
              <option id="5" >Last 60 Days</option>
              <option id="6" >Last 90 Days</option>
              <option id="7" >Last 180 Days</option>
              <option id="8" >Last 360 Days</option>
            </select>
          </div>
        </div>
      </div>
      <div className="result-section">
        {resultMap()}
      </div>
    </div>

  )
}

export default SearchSection;